export enum CURRENCY {
  XXX = "XXX",
  INR = "INR",
  BTC = "BTC",
}
